// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 493) return "wfmtrainerhub.34e746e8.css";
	// return url for filenames based on template
	return "" + chunkId + "." + "eb47639e" + ".chunk.css";
};